'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lang = require('lodash/lang');

var _translate = require('../../language/translate');

var _step2Functions = require('../../helpers/step2Functions');

var _commonFunctions = require('../../helpers/commonFunctions');

function isValidPhone(value) {
  return value && value.toString().length === 10;
}

exports.default = function (values, props) {
  return _extends({
    applicant: values.applicant.map(function (applicant, i) {
      var x = i + 1;
      return {
        sex: !applicant.sex && (0, _translate.t)('Applicant %(index)d: Gender is Required', { index: x }),
        address_line_1: i === 0 && !applicant.address_line_1 && (0, _translate.t)('Address Line 1 is Required'),
        city: i === 0 && !applicant.city && (0, _translate.t)('City is Required'),
        state: i === 0 && !applicant.state && (0, _translate.t)('Province/State is Required'),
        postal_code: i === 0 && !applicant.postal_code && (0, _translate.t)('Postal Code is Required'),
        phone: i === 0 && !isValidPhone(applicant.phone) && (0, _translate.t)('Phone Number must be 10 digits'),
        additional_data: {
          beneficiary_option: i === 0 && !applicant.additional_data.beneficiary_option && (0, _translate.t)('Declaring Beneficiary estate is required'),
          beneficiary_number: i === 0 && values.applicant[0].additional_data.beneficiary_option === 'no' && !applicant.additional_data.beneficiary_number && (0, _translate.t)('Beneficiary number is Required'),
          beneficiaries: i === 0 && applicant.additional_data.beneficiary_number > 0 && applicant.additional_data.beneficiaries.map(function (beneficiary, index) {
            return {
              first_name: !beneficiary.first_name && (0, _translate.t)('Beneficiary %(index)d: First Name is required', { index: index + 1 }),
              last_name: !beneficiary.last_name && (0, _translate.t)('Beneficiary %(index)d: Last Name is required', { index: index + 1 }),
              email: !(0, _commonFunctions.isEmailValid)(beneficiary.email) && (0, _translate.t)('Beneficiary %(index)d: Email is Invalid', { index: index + 1 }),
              phone_number: !isValidPhone(beneficiary.phone_number) && (0, _translate.t)('Beneficiary %(index)d: Phone Number must be 10 digits', { index: index + 1 }),
              relationship: !beneficiary.relationship && (0, _translate.t)('Beneficiary %(index)d: Relationship to Insured is required', { index: index + 1 }),
              payout: !beneficiary.payout && (0, _translate.t)('Beneficiary %(index)d: Benefit Payout is required', { index: index + 1 }) || isNaN(Number(beneficiary.payout)) && (0, _translate.t)('Beneficiary %(index)d: Benefit Payout must be a number', { index: index + 1 }) || Number(beneficiary.payout) > 100 && (0, _translate.t)('Beneficiary %(index)d: Benefit Payout must not exceed 100', { index: index + 1 })
            };
          }),
          beneficiary_total_payout: values.applicant[0].additional_data.beneficiary_option === 'no' && Number(applicant.additional_data.beneficiary_total_payout) !== 100 && (0, _translate.t)('Total Benefit Payout must be exactly 100')
        }
      };
    })
  }, (0, _step2Functions.validatePayment)(values, props));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/rimisecureadvantageplus/Applicants.js
// module id = 1780
// module chunks = 0